import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { Router } from '@angular/router';
import { PayuPaymentService } from '../../shared/services/payu-payment.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { AdminService } from 'src/app/business-service/admin/admin.service';

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss'],
})
export class PaymentDetailsComponent implements OnInit {

  @Input() usersAndCostData: any;
  @Input() selectedPackage: any;

  @Output() paymentCompleted: EventEmitter<void> = new EventEmitter<void>();
  @Output() saveBillingData: EventEmitter<any> = new EventEmitter<any>();
  @Output() storePayment: EventEmitter<boolean> = new EventEmitter<boolean>();

  billingForm!: FormGroup;

  @Input() storedFormData:any;

  constructor(
    private fb: FormBuilder,
    private _modalService: ModalsService,
    private _globalService: GlobalService,
    private _adminService: AdminService
  ) { }

  async ngOnInit(): Promise<void> {
    this.billingForm = this.fb.group({
      billingName: [
      '',
      [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern(/^[A-Za-z\s]+$/) // Only letters and spaces
      ]
      ],
      phoneNumber: [null, [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      gstin: [
      '',
      [
        Validators.maxLength(15),
        Validators.pattern(/^[A-Za-z0-9]+$/) // Only letters and numbers, no special chars
      ]
      ],
      address: [null],

      // packageDetails
      planSelected: [this.selectedPackage.packageName],
      packageId: [this.selectedPackage.packageId, Validators.required],
      productInfo: [this.selectedPackage.packageName],

      // Right-side form controls
      totalLicense: [this.usersAndCostData.noOfUsers],
      amount: [this.usersAndCostData.baseAmount],
      totalAmount: [this.usersAndCostData.totalAmount, [Validators.required]],

      isRegisteredForGSTIN: [false, Validators.required],
      txnId: [null]
    });

    if(!this.billingForm.get("isRegisteredForGSTIN")?.value){
      this.billingForm.get("gstin")?.setValue("");
      this.billingForm.get("gstin")?.disable();
    }

    this.billingForm.get("isRegisteredForGSTIN")?.valueChanges.subscribe((value: any) => {
      if (value) {
        this.billingForm.get("gstin")?.setValidators([Validators.required]);
        this.billingForm.get("gstin")?.enable();
        this.billingForm.get("gstin")?.updateValueAndValidity();
      } else {
        this.billingForm.get("gstin")?.setValidators([]);
        this.billingForm.get("gstin")?.setValue("");
        this.billingForm.get("gstin")?.disable();
        this.billingForm.get("gstin")?.updateValueAndValidity();
      }
    });

    let organizationDetails = await this.getOrganzationDetails(localStorage.getItem("CId"));
    let userDetails = organizationDetails.userDetails.userDetail;
    organizationDetails = organizationDetails.organizationDetails;

    if(this.storedFormData){
      this.billingForm.patchValue({
        ...this.storedFormData,
        isRegisteredForGSTIN : organizationDetails.isRegisteredForGSTIN || false,
        gstin: organizationDetails.gstin,
        address: {
          country: this.storedFormData.country || '',
          state: this.storedFormData.state || '',
          city: this.storedFormData.city || '',
          zipCode: this.storedFormData.zipCode || ''
        }
      })
    }else{
      if(organizationDetails){
        this.billingForm.patchValue({
          isRegisteredForGSTIN : organizationDetails.isRegisteredForGSTIN || false,
          gstin: organizationDetails.gstin,
          billingName: organizationDetails.name,
          phoneNumber: userDetails.officePhoneNumber,
          email: organizationDetails.email,
          address: {
            country: organizationDetails.country || '',
            state: organizationDetails.state || '',
            city: organizationDetails.city || '',
            zipCode: organizationDetails.zipCode || ''
          }
        })
      }
    }
  }

  async getOrganzationDetails(orgId: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this._adminService.getOrganization(orgId).subscribe({
        next: (data) => {
          resolve(data);
        }
      })
    })
  }

  calculateTax(amount: number, percent: number): number {
    return (amount * percent) / 100;
  }

  goToConfirmation() {
    if (this.billingForm.valid) {

      this.saveBillingData.emit(this.serializeFormData(this.billingForm.value));
      this.storePayment.emit(true);

    } else {
      this.billingForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Form is invalid, please fill all required fields.");
    }
  }

  privacyAndPolicy() {
    this._modalService.openPrivacyAndPolicy();
  }

  serializeFormData(formData: any):any{
    const serializedData = {
      ...formData,
      gstin: formData.isRegisteredForGSTIN ? formData.gstin : "",
      country: formData.address?.country?.name || '',
      state: formData.address?.state || '',
      city: formData.address?.city || '',
      zipCode: formData.address?.zipCode || '',
    }
    delete serializedData.address;
    return serializedData;
  }
}

